<template>
  <div class="loginForm">
    <div class="signin" v-if="IsShowLoginForm">
      <div class="header clearfix">
        <a class="logo" href="/">数字红会综合服务平台</a>
      </div>
      <!--header-->
      <div class="container">
        <div class="sign_box">
            <div class="bg_imgTwo">
              <img src="@/assets/images/bg_two.png" alt="" />
            </div>
          <div class="sign_box_title">用户登录</div>
          <div class="switchtab">
            <div class="switchtab_main">
              <div class="switchtab_main_box active" name="list-1">
                <dl>
                  <dt class="icon_user"></dt>
                  <dd>
                    <input
                      type="text"
                      placeholder="请输入账号"
                      v-model="Username"
                    />
                  </dd>
                </dl>
                <dl>
                  <dt class="icon_lock"></dt>
                  <dd>
                    <input
                      type="password"
                      placeholder="请输入密码"
                      v-model="Password"
                      @keyup.enter="loginHandle"
                    />
                  </dd>
                </dl>
                <!-- <dl>
                  <dt class="icon_lock"></dt>
                  <dd style="display: flex">
                    <input
                      placeholder="请输入验证码"
                      v-model="smsCode"
                      @keyup.enter="loginHandle"
                      style="width: 63%;margin-right: 10px"
                    />
                    <el-button @click="showValidDialog" :disabled="disabledBtn">{{btnTitle}}</el-button>
                  </dd>
                </dl> -->
                <dl>
                  <dt class="icon_lock"></dt>
                  <dd style="display: flex">
                    <input
                      placeholder="请输入验证码"
                      v-model="validCode"
                      @keyup.enter="loginHandle"
                      class="valid-code-input"
                      />
                    <img class="valid-code-img" :src="codeUrl" @click="getCodeImg" />
                  </dd>
                </dl>
              </div>
            </div>
            <div class="clearfix">
              <span class="sign_box_forget showModalMsg">{{
                ErrorMsg ? ErrorMsg : "&nbsp;"
              }}</span>
            </div>
            <div class="sign_box_footer" style="background-color:#fff">
              <button
                @click="loginHandle"
                :loading="IsSubmitting"
                style="background-color:#DC4D2B"
              >
                {{ ButtonName }}
              </button>
            </div>
          </div>
        </div>
        <div class="sign_bg">
            <img src="@/assets/images/body_bg.png" alt="bg" />
        </div>
      </div>
      <!--container-->
      <div class="footer">
        <div class="footer_content">
          <!-- <p>All rights reserved 版权所有：红十字会</p> -->
        </div>
      </div>
    </div>
    <div v-if="IsShowTenantList" class="mask">
      <div class="tenant-list">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="tenant-list-title">请选择登录系统：</span>
          </div>
          <div class="tenant-list-box">
            <div
              v-for="(item, index) in TenantPermissions"
              :key="index"
              @click.stop="tenantSelectedHandle(index)"
              class="tenant-item"
            >
              {{ item.TenantName ? item.TenantName : item.TenantId }}
              <i class="el-icon-arrow-right list-item-arrow"></i>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <el-dialog
      title="请输入验证码"
      :visible.sync="dialogVisible"
      width="25%"
      class="valid-code-dialog"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div class="validCode">
        <el-input
          placeholder="请输入验证码"
          v-model="validCode"
          @keyup.enter="loginHandle"
          class="valid-code-input"
          />
        <img class="valid-code-img" :src="codeUrl" @click="getCode" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sendSmsCode" :disabled="!validCode || validCode.length !== 4">发送</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { login, getAuthConfig, selectTenant, Syslogin ,isNeedChangePassworld,getCodeImg,getSmsCode } from "@/api/authorize.js";

export default {
  name: "of-login",
  data() {
    return {
      Username: "",
      Password: "",
      IsRemember: false,
      ErrorMsg: "",
      IsSubmitting: false,
      ButtonName: "登 录",
      IsShowLoginForm: true,
      IsShowTenantList: false,
      AuthResultData: null,
      codeUrl: '',
      uuid: '',
      validCode: '',
      dialogVisible: false,
      smsCode: '',
      cutTimer: null,
      btnTitle: '手机验证码',
      cutDownTime: 0,
      disabledBtn: false
    };
  },
  computed: {
    ...mapGetters(["GetUserToken", "GetRedirectUrl"]),
    Code() {
      return this.$route.query.code;
    },
    IsRelogin() {
      //return this.$route.query.isrelogin
      return this.$route.path === "/login2";
    },
    TenantPermissions() {
      if (this.AuthResultData && this.AuthResultData.TenantPermissions) {
        return this.AuthResultData.TenantPermissions;
      }
      return [];
    }
  },
  beforeDestroy () {
    clearInterval(this.cutTimer);
  },
  mounted() {
    this.getCodeImg()
    let token = this.GetUserToken;
    let redirectUrl = this.GetRedirectUrl;
    if (token) {
      if (redirectUrl) {
        this.$router.replace(redirectUrl);
      }
      return;
    }
    if (this.IsRelogin) {
      // this.IsShowLoginForm = true
      return;
    }
    if (this.Code) {
      this._login();
    } else {
      getAuthConfig().then(rep => {
        if (
          rep.data &&
          rep.data.Code === 0 &&
          rep.data.Data &&
          rep.data.Data.AuthenticationType === "IISAuthProxyService" &&
          rep.data.Data.LoginUrl
        ) {
          let url = rep.data.Data.LoginUrl;
          /*
         let logUrl = encodeURIComponent(location.href)
          var regtext = /(?<=redirect_uri=).*?(?=(\\&|$))/ig
          if(new RegExp(regtext).test(url)){
            url = url.replace(regtext,logUrl)
          }else{
              url = `${url}${url.indexOf('?')>-1?'&':'?'}redirect_uri=${logUrl}`
          }
          */
          location.href = url;
        } else {
          this.IsShowLoginForm = true;
        }
      });
    }
  },
  methods: {
    sendSmsCode(){
      const vm = this
      const param = {
        account: vm.Username,
        uuid: vm.uuid,
        code: vm.validCode
      }
      getSmsCode(param).then(res=>{
        if(res.data.Code === 0){
          vm.uuid = res.data.Data
          vm.dialogVisible = false
          vm.cutDownTime = 120
          vm.disabledBtn = true;
          vm.cutTimer = setInterval(() => {
            vm.btnTitle = vm.cutDownTime + '秒后重试';
            vm.cutDownTime--;
            if (vm.cutDownTime === 0) {
              vm.cutDownTime = 60;
              clearInterval(vm.cutTimer);
              vm.btnTitle = '获取验证码';
              vm.disabledBtn = false;
            }
          }, 1000);
        }else{
          this.ErrorMsg = res.data.Message
          vm.dialogVisible = false;
        }
      })
    },
    showValidDialog(){
      const vm = this
      vm.validCode = ''
      vm.ErrorMsg = ''
      vm.dialogVisible = true
      vm.getCodeImg()
    },
    handleClose(){
      const vm = this
      vm.dialogVisible = false
    },
    getCode(){
      const vm = this
      vm.getCodeImg()
    },
    getCodeImg(){
      const vm = this
      getCodeImg().then(res=>{
        if(res.data.Code === 0){
          vm.codeUrl = "data:image/gif;base64," + res.data.Data.Img
          vm.uuid = res.data.Data.Uuid
        }
        
      })
    },
    ...mapMutations({
      setCurrentMenus: "UPDATE_CURRENT_MENUS",
      setCurrentConfig: "UPDATE_CURRENT_CONFIG",
      setCurrentUserinfo: "UPDATE_CURRENT_USERINFO",
      setCurrentPermissions: "UPDATE_CURRENT_PERMISSIONS",
      setUsertoken: "UPDATE_USERTOKEN",
      setCurrrentTenants: "UPDATE_CURRENT_TENANT_LIST",
      setDefaultTenant: "UPDATE_DEFAULT_TENANT"
    }),
    loginHandle() {
      this.ErrorMsg = "";
      if (!this.Username) {
        this.ErrorMsg = "请输入用户名";
        return;
      }
      if (!this.Password) {
        this.ErrorMsg = "请输入密码";
        return;
      }
      if (!this.validCode ) {
        this.ErrorMsg = "请输入验证码"
        return;
      }
      this._login();
    },
    tenantSelectedHandle(index) {
      this._setAuthData(index);
    },
    _login() {
      this.IsSubmitting = true;
      this.ButtonName = "验证中，请稍候";
      Syslogin(this.Username, this.Password, this.Code,this.uuid,this.validCode).then(
        rep => {
          if (rep.data.Code === 0) {
            this.AuthResultData = rep.data.Data;
            if (this.AuthResultData && this.AuthResultData.TenantPermissions) {
              this.setCurrrentTenants(this.AuthResultData.TenantPermissions);
            }
            let defaultTenantId = "";
            if (this.AuthResultData && this.AuthResultData.DefaultTenant) {
              defaultTenantId = this.AuthResultData.DefaultTenant;
            }
            this.setDefaultTenant(defaultTenantId);
            if (
              this.AuthResultData &&
              this.AuthResultData.TenantPermissions &&
              this.AuthResultData.TenantPermissions.length > 1
            ) {
              var index = this.AuthResultData.TenantPermissions.findIndex(
                x => x.TenantId === defaultTenantId
              );
              if (index > -1) {
                this._setAuthData(index);
              } else {
                this.IsShowTenantList = true;
              }
            } else {
              this._setAuthData(-1);
            }
          } else {
            this.IsShowLoginForm = true;
            this.ErrorMsg = rep.data.Message;
            this.getCodeImg()
          }
          this.IsSubmitting = false;
          this.ButtonName = "登 录";
        },
        err => {
          this.IsShowLoginForm = true;
          this.ErrorMsg = JSON.stringify(err);
          this.IsSubmitting = false;
          this.ButtonName = "登 录";
        }
      );
    },
    _setAuthData(tenantIndex) {
      this.setCurrentMenus(this.AuthResultData.MenuList);
      this.setCurrentConfig(this.AuthResultData.Config);
      this.setCurrentUserinfo(this.AuthResultData.Operator);
      if (tenantIndex < 0) {
        this.setCurrentPermissions(this.AuthResultData.Permissions);
        this.setUsertoken(this.AuthResultData.UserToken);
        this._setTenantInfo(this.AuthResultData.TenantPermissions[0]);
      } else {
        this.setCurrentPermissions(
          this.AuthResultData.TenantPermissions[tenantIndex]
            .OperationPermissions
        );
        this.setUsertoken(
          this.AuthResultData.TenantPermissions[tenantIndex].Token
        );
        this._setTenantInfo(this.AuthResultData.TenantPermissions[tenantIndex]);
        selectTenant(
          this.AuthResultData.TenantPermissions[tenantIndex].TenantId
        ).then(() => {
          this.$router.push("/"); // 都跳转到首页
          // let url = this.GetRedirectUrl
          // if (url) {
          //   this.$router.push(url)
          // } else {
          //   this.$router.push('/')
          // }
        });
        return;
      }

      let url = this.GetRedirectUrl;
      if (url) {
        this.$router.push(url);
      } else {
        this.$router.push("/");
      }
    },
    _setTenantInfo(info) {
      localStorage.setItem("CurrentTenantInfo", JSON.stringify(info));
    }
  }
};
</script>

<style scoped lang="scss">
.bg_imgTwo {
  position:absolute;
  top: -110px;
  left: 50%;
  margin-left: -300px;
  width: 600px;
  img {
    width: 600px;
  }
}
.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 101;
  background-color: rgba(0, 0, 0, 0.6);
}
.mask >>> .el-card {
  border: none;
}
.mask >>> .el-card__header {
  padding: 15px 0;
  border: none;
}
.mask >>> .el-card__body {
  padding: 0;
}
.mask .tenant-list {
  position: relative;
  top: 48%;
  left: 50%;
  margin-left: -190px;
  margin-top: -175px;
  width: 380px;
}
.mask .tenant-list .tenant-item {
  line-height: 40px;
  margin: 10px;
  padding: 0 20px 0 15px;
  border: 1px solid #ddd;
  color: #707070;
  border-radius: 5px;
  background: rgba(249, 249, 249, 1);
  font-size: 15px;
  font-weight: bolder;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  left: 0;
  top: 0;
}

.mask .tenant-list .tenant-item:hover {
  background: rgba(239, 248, 255, 1);
  border-color: #004a86;
  color: #004a86;
  cursor: pointer;
}
.tenant-list-title {
  font-weight: 800;
  border-left: 3px solid #004a86;
  padding-left: 15px;
  font-size: 16px;
}
.tenant-list-box {
  max-height: 300px;
  overflow: auto;
  padding: 0 10px 10px 10px;
}
.tenant-item:hover .list-item-arrow {
  display: block;
}
.list-item-arrow {
  /* float:right; */
  position: absolute;
  right: 10px;
  top: 0;
  line-height: 42px;
  font-weight: bolder;
  display: none;
}
.validImg:hover{
  cursor:pointer
}

.valid-code-input{
      width: 63%;
      margin-right: 10px;
      /deep/ .el-input__inner{
        height: 50px !important;
      }
    }
    .valid-code-img{
      width: 37%;
      height: 50px;
    }
</style>
<style lang="scss" scoped>
.valid-code-dialog{
  top: 30vh;

  .validCode{
    display: flex;
    .valid-code-input{
      width: 63%;
      margin-right: 10px;
      /deep/ .el-input__inner{
        height: 50px !important;
      }
    }
    .valid-code-img{
      width: 37%;
      height: 50px;
    }
    .valid-code-img:hover{
    cursor:pointer
    }
  }
}
</style>
